export default {
    cache : {},
    events : {},
    promises : {},
    states : {},
}



//////////////////
// WEBPACK FOOTER
// ./public/js/services/storage.js
// module id = 651
// module chunks = 0